<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div formArrayName="insurerDocuments">
                @for (
                  insurerDocument of insurerDocuments.controls;
                  track insurerDocument;
                  let i = $index
                ) {
                  <div
                    class="insurer-documents-container mt-1"
                    [formGroupName]="i"
                  >
                    <p class="insurer-document-label">
                      {{ insurerDocument.get('label').value }}
                    </p>
                    <div
                      class="insurer-document-box-download"
                      (click)="
                        onClickDownloadDocument(
                          insurerDocument.get('label').value,
                          insurerDocument.get('gedId').value
                        )
                      "
                    >
                      <pr-icon
                        name="sp-download"
                        [width]="24"
                        [viewBoxWidth]="24"
                        [viewBoxHeight]="24"
                      ></pr-icon>
                    </div>
                  </div>
                }
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
